module.exports = __webpack_public_path__ + "media/educator_advisory_board/Tracy_Brower-eedbc5c5.png";